import "date-fns";
import React, { useState, useEffect, memo  } from "react";
import { tr } from "date-fns/locale";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";

function DatePicker(props) {
  const [errorState, setErrorState] = useState(false);

  useEffect(() => {
    props.setInputData((prevState) => {
      return {
        ...prevState,
        [props.propName]: {
          ...prevState[props.propName],
          error: errorState,
        },
      };
    });
  }, [errorState]);

  const setErrorStateToParent = (errorString, value) => {
    if (errorString === "" ) {
      setErrorState(false);
    } else {
      setErrorState(true);
    }
  };

  return (
    <MuiPickersUtilsProvider locale={tr} utils={DateFnsUtils}>
      <KeyboardDatePicker
        autoOk={true}
        variant="inline"
        onError={(error, value) => {
          setErrorStateToParent(error, value);
        }}
        style={{ width: "100%", margin: 0, fontFamily: "SommetRoundedLight" }}
        size="small"
        inputVariant="outlined"
        format="dd/MM/yyyy"
        margin="normal"
        value={props.obj.value}
        onChange={props.onChange}
        disabled={props.disabled}
        animateYearScrolling={true}
        maxDate={new Date()}
        error={props.validationCheckError}
        helperText={props.validationCheckError ? props.invalidDateMessage : ""}
        InputProps={{
          style: { fontFamily: "SommetRoundedLight", fontSize: "16px!important" },
        }}
      />
    </MuiPickersUtilsProvider>
  );
}

export default memo(DatePicker);
